// extracted by mini-css-extract-plugin
export var container = "_s0-0";
export var dotAnimation = "_s0-2";
export var dotsLoading = "_s0-1";